import { Component, Input } from '@angular/core';
import { CalendarEvent } from 'calendar-utils';


export class CalendarEventTitleComponent {

   event: CalendarEvent;

   view: string;

static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  selector: 'mwl-calendar-event-title',
  template: `
    <a
      class="cal-event-title"
      href="javascript:;"
      [innerHTML]="event.title | calendarEventTitle:view:event">
    </a>
  `
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'event': [{ type: Input },],
'view': [{ type: Input },],
};
}
interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
